<div class="model-select-dialog">
  <div class="dialog-header">
    <div class="title-placeholder"></div>
    <h2 class="dialog-title">Drag AI models to Left and Right</h2>
    <button class="exit-btn" type="button" (click)="dialogRef.close()">✕</button>
  </div>

  <div class="actions actions--top">
    <button mat-raised-button color="primary" type="button" (click)="apply()">Apply</button>
    <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
  </div>

  <div #dialogContainer class="scrollable-content">
    <p class="catalog-hint">Same model lineup as the Clari Chat AI catalog (grouped below).</p>

    <div
      class="available-row"
      cdkDropList
      id="availableList"
      [cdkDropListData]="availableModels"
      [cdkDropListConnectedTo]="['leftList', 'rightList']"
      (cdkDropListDropped)="drop($event)"
    >
      <div
        class="model-card model-color"
        *ngFor="let model of orderedAvailable"
        cdkDrag
        (cdkDragMoved)="onDragMoved($event)"
      >
        {{ model.name }}
      </div>
    </div>

    <div class="columns-container">
      <div
        class="column left-column"
        cdkDropList
        id="leftList"
        [cdkDropListData]="leftList"
        [cdkDropListConnectedTo]="['availableList', 'rightList']"
        (cdkDropListDropped)="drop($event)"
      >
        <div class="column-title">Left — {{ leftList[0]?.name || 'No model' }}</div>
        <div class="placeholder" *ngIf="leftList.length === 0">Drag a model here</div>
        <div
          class="model-card"
          *ngFor="let model of leftList"
          cdkDrag
          (cdkDragMoved)="onDragMoved($event)"
        >
          {{ model.name }}
        </div>
      </div>

      <div
        class="column right-column"
        cdkDropList
        id="rightList"
        [cdkDropListData]="rightList"
        [cdkDropListConnectedTo]="['availableList', 'leftList']"
        (cdkDropListDropped)="drop($event)"
      >
        <div class="column-title">Right — {{ rightList[0]?.name || 'No model' }}</div>
        <div class="placeholder" *ngIf="rightList.length === 0">Drag a model here</div>
        <div
          class="model-card"
          *ngFor="let model of rightList"
          cdkDrag
          (cdkDragMoved)="onDragMoved($event)"
        >
          {{ model.name }}
        </div>
      </div>
    </div>
  </div>

  <div class="actions actions--bottom">
    <button mat-raised-button color="primary" type="button" (click)="apply()">Apply</button>
    <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
  </div>
</div>
